import { Curriculum } from "../../types/curriculum";
import { CurriculumServiceInterface } from "./CurriculumServiceInterface";
export class CurriculumServiceFirestore extends CurriculumServiceInterface {
    static COLLECTION = "curriculums";
    firestore;
    constructor(firestore) {
        super();
        this.firestore = firestore;
    }
    async getCurriculums() {
        const snapshot = await this.firestore
            .collection(CurriculumServiceFirestore.COLLECTION)
            .orderBy("title")
            .get();
        return snapshot.docs.map((doc) => {
            const data = doc.data();
            const curriculum = new Curriculum(data);
            curriculum.id = doc.id;
            return curriculum;
        });
    }
    async getCurriculum(curriculumId) {
        const doc = await this.firestore
            .collection(CurriculumServiceFirestore.COLLECTION)
            .doc(curriculumId)
            .get();
        if (!doc.exists) {
            throw new Error(`Curriculum with id ${curriculumId} not found`);
        }
        const data = doc.data();
        const curriculum = new Curriculum(data);
        curriculum.id = doc.id;
        return curriculum;
    }
    async createCurriculum(curriculumData) {
        const curriculum = new Curriculum(curriculumData);
        const curriculumForFirestore = {
            id: curriculum.id,
            title: curriculum.title,
            description: curriculum.description,
            status: curriculum.status,
            lessons: curriculum.lessons,
            modules: curriculum.modules,
            createdAt: this.firestore.fieldValue.serverTimestamp(),
            updatedAt: this.firestore.fieldValue.serverTimestamp(),
        };
        await this.firestore
            .collection(CurriculumServiceFirestore.COLLECTION)
            .doc(curriculum.id)
            .set(curriculumForFirestore);
        return curriculum;
    }
    async updateCurriculum(curriculumId, curriculumData) {
        const docRef = this.firestore
            .collection(CurriculumServiceFirestore.COLLECTION)
            .doc(curriculumId);
        const doc = await docRef.get();
        if (!doc.exists) {
            throw new Error(`Curriculum with id ${curriculumId} not found`);
        }
        const curriculum = await this.getCurriculum(curriculumId);
        curriculum.update(curriculumData);
        const updateData = {
            title: curriculum.title,
            description: curriculum.description,
            status: curriculum.status,
            lessons: curriculum.lessons,
            modules: curriculum.modules,
            updatedAt: this.firestore.fieldValue.serverTimestamp(),
        };
        await docRef.update(updateData);
        return curriculum;
    }
}
